import React from 'react'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'


const Instruction = ({ ...props }) =>
  <InstructionBlock>
    <Slogan>Effortless. Innovative. Trusted.</Slogan>
    <Steps>
      <StepBlock>
        <StepIcon asset="surface" alt="Surface" height={ 49 } width={ 134 } />
        <Step>1. Tell Us What You Drive</Step>
        <Description>Choose your vehicle’s Make, Year, Model and Submodel to get things started.</Description>
      </StepBlock>
      <StepBlock>
        <StepIcon asset="pazzle" alt="Pazzle" height={ 80 } width={ 84 } />
        <Step>2. We’ll Find You the Perfect Fit</Step>
        <Description>We will narrow in on tires that fit your vehicle from the millions that we carry.</Description>
      </StepBlock>
      <StepBlock>
        <StepIcon asset="car" alt="Car" height={ 79 } width={ 79 } />
        <Step>3. Pick The Most Convenient Installer</Step>
        <Description>After you select your new tires,
          find an installer that fits into your hectic schedule.</Description>
      </StepBlock>
    </Steps>
  </InstructionBlock>

export default Instruction


const InstructionBlock = styled.div`
  width: 1065px;
  margin: 0 auto;
  padding: 50px;
  background-color: ${Theme.colors.veil};
  text-align: center;
`

const Slogan = styled.p`
  margin: 0;
  margin-bottom: 40px;
  color: ${Theme.colors.blue};
  ${Mixin.font.GothamBold(48)}
`

const StepBlock = styled.div`
  display: table-cell;
  padding: 0 70px;
`

const Step = styled.p`
  font-size: 18px;
  font-weight: 700;
  color: ${Theme.colors.blue};
`

const Steps = styled.div`
  display: table;
`

const StepIcon = styled(Icon)`
  margin-bottom: 30px;
`

const Description = styled.span`
  line-height: 30px;
  font-size: 16px;
  font-weight: 400;
`
